export default __webpack_public_path__ + "static/media/how_it_works_border.2aa7cbb2.png";